import React, { Component } from 'react';
import Textarea from 'react-textarea-autosize';
import { theme } from 'constants';

const styles = {
  input: {
    backgroundColor: 'white',
    resize: 'none',
    borderStyle: 'solid',
    borderWidth: theme.hairline + 'px',
    borderRadius: '10px',
    borderColor: theme.gray_color_lighten(),
    outline: 'none',
    width: 'auto',
    minHeight: 30,
    paddingLeft: 15,
    paddingRight: 15,
    paddingTop: 4,
    boxSizing: 'border-box'
  }
};

export class WebTextArea extends Component {
  render() {
    let { max_row, min_row, onChangeText, placeholder, font_size, value, style, onReturn } = this.props;
    min_row = min_row || 1;
    max_row = max_row || 5;
    const fontSize = font_size || 18;

    return (
      <Textarea
        minRows={min_row}
        maxRows={max_row}
        style={{ ...styles.input, fontSize, ...style }}
        onChange={e => onChangeText && onChangeText(e.target.value)}
        onKeyDown={e => {
          if (onReturn && !e.shiftKey && e.keyCode === 13) {
            onReturn && onReturn();
            e.preventDefault();
          }
        }}
        value={value}
        placeholder={placeholder}
        // todo: detecting enter key and send message after it
      />
    );
  }
}

export const TextArea = WebTextArea;



// WEBPACK FOOTER //
// ./src/components/core/text_area.web.js